import React from "react";
import { Container } from "react-bootstrap";
import backarrow from "../../assets/svg/nav-prev.svg";
import { ReactComponent as UnAuthorizedIcon } from "../../assets/svg/unauthorized.svg";
import { useNavigate } from "react-router-dom";

const UnAuthorized = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <Container
      fluid
      style={{
        width: "100%",
        minHeight: "100vh",
        padding: "0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F3F6F9",
      }}
    >
      <div
        style={{
          width: "600px",
          maxWidth: "90%",
          background: "#FFFFFF",
          borderRadius: "24px",
          padding: "48px 32px",
          textAlign: "center",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        }}
      >
        <UnAuthorizedIcon style={{ maxWidth: "100%", height: "auto" }} />
        <p
          className="mt-3"
          style={{
            fontSize: "28px",
            fontWeight: "700",
            color: "#212129",
            marginBottom: "8px",
          }}
        >
          Unauthorized !!
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              maxWidth: "380px",
              fontSize: "15px",
              fontWeight: "400",
              color: "#8790A1",
              lineHeight: "1.5",
              marginBottom: "24px",
            }}
          >
            You don’t have permission to access this page or perform this action.
            Please go back to home to access the application.
          </p>
        </div>
        <button
          type="button"
          onClick={handleBackToHome}
          style={{
            backgroundColor: "#6929E2",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "100px",
            fontWeight: "700",
            fontSize: "15px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
          className="px-4 py-2"
        >
          <img
            src={backarrow}
            alt="back"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          Back to home
        </button>
      </div>
    </Container>
  );
};

export default UnAuthorized;
